import { MuiThemeProvider } from "@material-ui/core/styles";
import { createTheme } from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { Component } from "react";
import ct from "../modules/custom/customTable";

const getMuiTheme = () => createTheme(ct.customTable());

/**
 * @prop {List<Object>} [data] - mandatory
 * @prop {List<Object>} [column] - mandatory
 * @prop {int} [toCount] - optional
 * @prop {int} [rowsPerPage] - mandatory
 * @prop {int} [page] - mandatory
 * @prop {string} [title] - optional
 * @prop {Object} [options] - optional
 */
class SimpleDataTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      title,
      data,
      footerAdditionalButtons,
      columns,
      options = {},
      toCount,
      rowsPerPage,
      page,
    } = this.props;
    const tableOptions = {
      ...ct.customOptions6(),
      filter: false,
      search: false,
      viewColumns: false,
      serverSide: true,
      count: toCount, // reset page when change the rowsPerPage
      rowsPerPage: rowsPerPage,
      page: page,
      customToolbarSelect: () => {
        return null;
      },
      ...options,
    };

    return (
      <div style={{ position: "relative" }}>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            key={toCount}
            title={title}
            data={data}
            columns={columns}
            options={tableOptions}
          />
        </MuiThemeProvider>
        <div
          style={{
            position: "absolute",
            bottom: "8px",
            right: "20px",
          }}
        >
          {footerAdditionalButtons}
        </div>
      </div>
    );
  }
}

export default SimpleDataTable;
